/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Enhanced_Your_ListingInputs */

const en_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI enhanced your listing ✨`)
};

const es_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA ha mejorado tu anuncio ✨`)
};

const fr_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA a amélioré votre annonce ✨`)
};

const de_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI hat dein Inserat verbessert ✨`)
};

const ja_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIが出品情報を強化しました ✨`)
};

const zh_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 已增强您的商品信息 ✨`)
};

const ar_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تحسين إعلانك بالذكاء الاصطناعي ✨`)
};

const id_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI menyempurnakan listing Anda ✨`)
};

const it_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA ha migliorato il tuo annuncio ✨`)
};

const ru_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ улучшил ваше объявление ✨`)
};

const pt_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA melhorou o seu anúncio ✨`)
};

const ko_ai_enhanced_your_listing = /** @type {(inputs: Ai_Enhanced_Your_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI가 상품 정보를 개선했습니다 ✨`)
};

/**
* | output |
* | --- |
* | "AI enhanced your listing ✨" |
*
* @param {Ai_Enhanced_Your_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_enhanced_your_listing = /** @type {((inputs?: Ai_Enhanced_Your_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Enhanced_Your_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_enhanced_your_listing(inputs)
	if (locale === "es") return es_ai_enhanced_your_listing(inputs)
	if (locale === "fr") return fr_ai_enhanced_your_listing(inputs)
	if (locale === "de") return de_ai_enhanced_your_listing(inputs)
	if (locale === "ja") return ja_ai_enhanced_your_listing(inputs)
	if (locale === "zh") return zh_ai_enhanced_your_listing(inputs)
	if (locale === "ar") return ar_ai_enhanced_your_listing(inputs)
	if (locale === "id") return id_ai_enhanced_your_listing(inputs)
	if (locale === "it") return it_ai_enhanced_your_listing(inputs)
	if (locale === "ru") return ru_ai_enhanced_your_listing(inputs)
	if (locale === "pt") return pt_ai_enhanced_your_listing(inputs)
	return ko_ai_enhanced_your_listing(inputs)
});